module.exports = __webpack_public_path__ + "static/media/Logo-Purple.58ac319e.png";